'use client';

import { Help } from '@shared/icons';
import { Withdraw } from '@shared/icons/system';
import { NumberFormats, ROUTES, useCurrencyFormatter } from '@shared/utils';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { NavigationPod } from '../../../../NavigationPod/NavigationPod';
import type { WithdrawalFormData } from '../WithdrawSheet';

type WithdrawErrorStepProps = {
  namespace?: string;
  onMount?: () => void;
  'data-track-status'?: string;
  'data-track-error'?: string;
  'data-track-method'?: string;
  'data-track-amount'?: string;
  'data-track-id'?: string;
  'data-track-category'?: string;
  'data-track-type'?: string;
  'data-track-count'?: string;
  'data-track-container'?: string;
};

function WithdrawErrorStep({ namespace, onMount, ...props }: WithdrawErrorStepProps) {
  const t = useTranslations(namespace);
  const formatCurrency = useCurrencyFormatter();
  const { watch } = useFormContext<WithdrawalFormData>();

  const amount = watch('amountStep.amount');

  useEffect(() => {
    onMount?.();
  }, [onMount]);

  return (
    <div data-testid="withdraw-error-step" {...props}>
      <div className="flex flex-col gap-5">
        {/* Icon */}
        <Withdraw size="extra-extra-large" />

        {/* Title and description */}
        <div className="flex flex-col gap-2">
          <h4 data-testid="withdraw-error-message">
            {t('error_step.title', {
              amount: formatCurrency(Number(amount) * 100)
                .format(NumberFormats.WITH_DECIMALS)
                .get(),
            })}
          </h4>
          <p className="paragraph text-muted-foreground" data-testid="withdraw-error-description">
            {t('error_step.description')}
          </p>
        </div>

        {/* Home Centre card */}
        <div className="flex flex-col gap-2.5 pt-5">
          <h5>{t('error_step.need_help')}</h5>
          <NavigationPod
            icon={Help}
            label={t('error_step.card_label')}
            href={ROUTES.HELP_CENTRE.BASE_URL}
            variant="action"
            hierarchy="default"
            data-testid="help-centre-card"
            data-track-name="Help Centre"
          />
        </div>
      </div>
    </div>
  );
}

export { WithdrawErrorStep };
